import styled from "@emotion/styled";
export const PreviewRoot = styled.div`
  padding-top: 1rem;
`;
export const PreviewHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
`;
export const PreviewIconContainer = styled.div`
  display: flex;
  align-items: flex-end;
`;
export const PreviewButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
